import React, {useState ,useRef, useEffect, useContext} from 'react';
import "./GroupModal.scss";
import './Adaptations.scss'
import MarkerText from "../map/markers/MarkerText";
import {PIN_OFFSETS} from "../map/markers/markerUtils";
import CloseBtn from '../close-btn/CloseBtn';
import { useNavigate } from 'react-router-dom';
import { MainContext } from "../../contexts/MainContext";

const PIN_SIZE = {width: 20, height: 40};

export default function GroupModal({closeFunction, groupModal, align = "right" }) {

    const ref = useRef(null);
    const navigate = useNavigate();
    const { allCommunities } = useContext(MainContext);
    
    const [viewBox, setViewBox] = useState('0 0 623 334');
    const [isPortrait, setIsPortrait] = useState(false);

    // Function to check if a community exists for a property
    const checkCommunityExists = (property) => {
        if (!property || !property.path) return false;
        
        // For a path like "/dubai/al-jaddaf/art-bay", we need to check if "/dubai/al-jaddaf" exists
        const pathParts = property.path.split('/');
        
        // Need at least 3 parts: ["", "dubai", "al-jaddaf", "art-bay"]
        if (pathParts.length < 4) return false;
        
        // Construct the community path: /dubai/al-jaddaf
        const communityPath = `/${pathParts[1]}/${pathParts[2]}`;
        
        // Find the community
        const community = allCommunities.find(community => 
            community.path === communityPath
        );
        
        // Check if community exists AND has a valid bird property
        return community && community.bird;
    };

    useEffect(() => {
        const handleResize = () => {
            const isInPortrait = window.matchMedia("(max-width: 834px) and (orientation: portrait)").matches;
            setIsPortrait(isInPortrait);
            // Keep viewBox consistent regardless of orientation
            setViewBox('0 0 623 334');
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Function to transform coordinates based on orientation
    const transformCoordinates = (coords) => {
        // In portrait mode, we don't need to transform the coordinates
        // since we're keeping the viewBox consistent
        return coords;
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                closeFunction();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);
    
    // Check if modal_map_coords_pin exists, if not provide an empty array to prevent errors
    const mapPins = (groupModal?.modal_map_coords_pin || [])
        .filter(marker => marker.enabled === undefined || marker.enabled === true);

    // Handle navigation with community existence check
    const handleMarkerClick = (marker) => {
        if (!checkCommunityExists(marker)) {
            // Don't navigate if the community doesn't exist or doesn't have a bird
            return;
        }
        navigate(marker.path);
    };

    return (
        <>
            <div className="group-modal" ref={ref}>
                {groupModal?.modal_map && (
                    <img
                        alt="map-background"
                        className='modal-image'
                        src={groupModal.modal_map}
                    />
                )}
                <CloseBtn closeState={closeFunction}/>
                <svg viewBox={viewBox}>
                    {mapPins.map((marker, index) => {
                        const isValidProperty = checkCommunityExists(marker);
                        const transformedCoords = transformCoordinates(marker.coords);
                        
                        return (
                            <g
                                key={index}
                                className="marker-group"
                                onClick={() => handleMarkerClick(marker)}
                                style={{
                                    cursor: isValidProperty ? 'pointer' : 'not-allowed'
                                }}
                                // data-coords={coords.join(",")}
                                // data-name={groupModal.name}
                            >
                                <g className="marker-icon">
                                    <svg
                                        x={transformedCoords[0] - PIN_SIZE.width / 2}
                                        y={transformedCoords[1] - PIN_SIZE.height}
                                        className="image-pins"
                                        width={PIN_SIZE.width}
                                        height={PIN_SIZE.height}
                                        viewBox="0 0 18 25"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            x="-15"
                                            y="-15"
                                            width="30"
                                            height="30"
                                            fill="transparent"
                                        />
                                        <g>
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M16.7254 12.6478C17.1833 11.5369 17.4375 10.3085 17.4375 9.0167C17.4375 4.03691 13.6599 0 9 0C4.3401 0 0.5625 4.03691 0.5625 9.0167C0.5625 10.0706 0.731703 11.0823 1.04266 12.0224L1.03125 12.022C1.06361 12.106 1.09657 12.1902 1.13011 12.2747C1.22534 12.5372 1.33174 12.7938 1.4487 13.0437C3.17275 17.0436 6.08638 21.4315 9 24.5452C12.1641 21.1639 15.5156 15.7539 16.7344 12.6481L16.7254 12.6478Z"
                                                fill="black"
                                            />
                                            <ellipse cx="9" cy="8.13823" rx="4.5" ry="4.50835" fill="white"/>
                                        </g>
                                    </svg>

                                    <MarkerText
                                        name={marker.name}
                                        coords={transformedCoords}
                                        align={marker.align}
                                        pinSize={PIN_SIZE}
                                        marginToNextLine={PIN_OFFSETS.groupsMarkers.marginToNextLine}
                                        offsets={PIN_OFFSETS.groupsMarkers}
                                    />

                                </g>
                            </g>
                        );
                    })}
                </svg>
            </div>
        </>
    );
};
